import { Box } from "@mui/material";
import { Row } from "../../../../../../../../../components/CustomTooltip";
import { NonNullableDate } from "../../../../../../../../../utils/date-time-utility";
import {
  DEFAULT_BG_COLOR,
  DEFAULT_LABEL_COLOR,
} from "../../../../../../../../../utils/utils";
import Text from "../../../../../../../../../components/Text";

interface CarePlanData {
  goals: string;
  title: string;
  // condition: string;
  deception: string;
  startDate: Date;
  endDate: Date;
  active: boolean;
}

export const CarePlanTooltip: React.FC<{ data: CarePlanData }> = ({ data }) => (
  <Box sx={{ minWidth: 250 }}>
    {/* Title Bar */}
    <Box
      sx={{
        background: DEFAULT_BG_COLOR,
        padding: "8px 12px",
      }}
    >
      <Text color={DEFAULT_LABEL_COLOR}>Care Plan Details</Text>
    </Box>
    {/* Content */}
    <Box
      sx={{
        padding: "12px 16px",
        display: "flex",
        flexDirection: "column",
        gap: "4px",
      }}
    >
      <Row label="Name" value={data?.title} />
      {/* <Row label="Goals" value={data?.goals} /> */}
      {/* <Row label="Condition" value={data?.condition} /> */}
      <Row label="Start Date" value={NonNullableDate(data?.startDate)} />
      <Row label="End Date" value={NonNullableDate(data?.endDate)} />
      <Row label="Status" value={data?.active ? "Active" : "Inactive"} />
      <Row label="Description" value={data?.deception} multiline />
    </Box>
  </Box>
);
